<template>
  <component
    ref="imgEl"
    v-bind="{ ...$props, ...$attrs }"
    v-on="$listeners"
    :is="tagName"
  ></component>
</template>
<script>
export default {
  name: '',
  props: {
    // 实际的dom标签名称【默认为图片，也有可能是div或者span等吧图片作为背景的标签】
    tagName: {
      type: String,
      default: 'img'
    },
    // 图片地址
    imgUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      scrollTimer: null
    }
  },
  created() {},
  mounted() {
    if (this.imgUrl) {
      this.initLazyLoad() // 有些是默认图片的展示，非异步图片，所以需要再mounted之后便直接加载，否则会出现展示不出的情况
    }
  },
  methods: {
    // 初始化加载方法
    initLazyLoad() {
      // 如果初始化的时候元素不在视口中，那么添加滚动处理方法，以便在滚动的过程中检测该元素是否在视口中
      if (!this.isShowInViewport()) {
        window.addEventListener('scroll', this.scrollThrottleLoad)
        return
      }
      this.loadImg()
    },
    // 滚动节流加载【防止触发太多处理】
    scrollThrottleLoad() {
      if (this.scrollTimer) {
        clearTimeout(this.scrollTimer)
      }
      this.scrollTimer = setTimeout(this.loadImg, 200)
    },
    // 加载图片
    loadImg() {
      // 如果元素在视口中
      if (this.isShowInViewport()) {
        // 清除滚动节流定时器
        clearTimeout(this.scrollTimer)
        // 移出对应的scroll事件处理方法，因为每个懒加载图片元素都在window上面注册了一个该方法，所以图片加载后需要清除，防止内存占用
        window.removeEventListener('scroll', this.scrollThrottleLoad)
        // 如果是图片元素，那么直接赋值给src属性
        if (this.tagName === 'img') {
          this.$refs.imgEl.src = this.imgUrl
        } else {
          // 否则赋值给他的background-image属性
          this.$refs.imgEl.style.backgroundImage = `url(${this.imgUrl || '#'})`
        }
      }
    },
    // 判断元素是否出现在视口中
    isShowInViewport() {
      const windowScrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop
      const winHeight =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight
      const offsetTop = this.getOffestValue(this.$refs.imgEl).top
      const domHeight = this.$refs.imgEl.offsetHeight
      if (
        windowScrollTop > offsetTop - winHeight &&
        windowScrollTop < offsetTop + domHeight
      ) {
        return true
      } else {
        return false
      }
    },
    /**
     * @desc 获取元素相对于某个父级的位置
     * @param {string} elem 元素
     * @param {string} parent 父级
     * @returns {object}
     */
    getOffestValue(elem, parent) {
      var topValue = elem.offsetTop
      var leftValue = elem.offsetLeft
      var offsetFar = elem.offsetParent
      while (offsetFar) {
        if ((parent && offsetFar === parent) || !offsetFar) {
          break
        }
        topValue += offsetFar.offsetTop
        leftValue += offsetFar.offsetLeft
        offsetFar = offsetFar.offsetParent
      }
      return {
        top: topValue,
        left: leftValue
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollThrottleLoad)
  },
  watch: {
    imgUrl(val) {
      if (val) {
        this.$nextTick(this.initLazyLoad)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/gtn/components/uplus/lazyLoadImg.vue